import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import { styled } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

const Box = styled('div')(({ theme, width, vertical, horizontal }) => ({
  background: 'var(--status-amber-bg)',
  border: '1px solid var(--status-amber-border)',
  borderRadius: '4px',
  display: 'flex',
  alignItems: vertical ? vertical : 'center',
  justifyContent: horizontal ? horizontal : 'center',
  width: width ? width : 'fit-content',
  padding: '8px 12px',
  fontSize: '14px',
  color: 'var(--status-amber-color)',
}));

const Error = styled(ErrorIcon)({
  color: 'var(--status-amber-color)',
  marginRight: '12px',
  width: '16px',
  height: 'auto',
  paddingTop: '2px',
});

function WarningBox({ text, hideIcon, width, vertical, horizontal }) {
  return (
    <Box width={width} vertical={vertical} horizontal={horizontal}>
      {!hideIcon && <Error />}
      {text}
    </Box>
  );
}

WarningBox.propTypes = {
  text: PropTypes.string.isRequired,
};

export default WarningBox;
